import React from "react";
import { Spinner } from "../ui/spinner";

export type LoadBoxType = {
  loading: boolean;
  children: React.ReactNode;
  minHeight?: string;
};

function LoadBox({ children, loading, minHeight }: LoadBoxType) {
  if (loading) {
    return (
      <div
        className="flex justify-center items-center h-full w-full"
        style={{ minHeight: minHeight || "300px" }}
      >
        <Spinner size="lg" />
      </div>
    );
  }
  return <>{children}</>;
}

export default LoadBox;
